// extracted by mini-css-extract-plugin
export default {"LoggedInDevicesHeader":"SecurityPage_LoggedInDevicesHeader__+n2oD"};